/** Plain-language tool-call labels, shared by the inline ToolPart card and the thinking-trail steps. */

// Plain-language verbs for the tools the agent calls; unknown tools are humanized.
export const TOOL_LABELS: Record<string, string> = {
  query_factor_exposures: "Analyzed factor exposures",
  query_positions: "Fetched holdings",
  optimize_hedge: "Optimized a hedge",
  run_op_skill: "Ran an Omega Point workflow",
}

export function humanize(toolName: string): string {
  return toolName.replace(/[_-]+/g, " ").replace(/\b\w/, (character) => character.toUpperCase())
}

/** Friendly label for a tool invocation: explicit title, then the known-tool map, then a humanized wire name. */
export function toolDisplayLabel(title: string | undefined, toolName: string | undefined): string {
  return title || (toolName ? (TOOL_LABELS[toolName] ?? humanize(toolName)) : "Working")
}
